import { FirebaseTimestampType } from 'firebase/index'
import { CheckoutItemType } from './checkoutItem'
import { StockUnionType } from 'types/stock'

// ordersとして管理
export type CheckoutState = {
  is_set_unsubscribe: boolean
  orders: OrderType[]
  unsubscribes: Array<() => void>
  orderTimes: OrderTime[]
}

// checkoutとitemsをマージ
export type OrderType = CheckoutType & { items: CheckoutItemType[] }

export type CheckoutType = {
  amount: number
  checkout_at: FirebaseTimestampType
  checkout_id?: string
  checkout_channel?: CheckoutChannel
  created_at: FirebaseTimestampType
  date: string
  delivery_fee_amount?: number // 通販｜配送料
  discount_amount?: number
  fee_rate?: number // sacri手数料率(0.1 or 0.136)
  frozen_fee_amount?: number // 通販｜クール便手数料
  is_delivered: boolean // 受渡済かどうか
  is_prepared: boolean // 準備済かどうか
  name: string
  payment_intents: string[]
  payment_method: string
  pickup_time: string
  price: number
  quantity: number
  request: string
  shopping_bags: CheckoutShoppingBagType[]
  status: CheckoutStatusType
  type: StockUnionType
  updated_at: FirebaseTimestampType
  user_id: string
}

export type CheckoutStatusType = 'pending' | 'succeeded' | 'canceled' | 'requires_capture'

export type CheckoutShoppingBagType = {
  name: string
  price: number
  quantity: number
}

export type OrderTime = {
  times: number
  user_id: string
}

export type SortKey = 'checkout_at' | 'pickup_time'
export type SortOrder = 'asc' | 'desc'

export type DeliveryOrderCsvRow = {
  お客様管理番号: string
  送り状種類: string
  クール区分: string
  伝票番号: string
  出荷予定日: string
  お届け予定日: string
  配達時間帯: string
  お届け先コード: string
  お届け先電話番号: string
  お届け先電話番号枝番: string
  お届け先郵便番号: string
  お届け先住所: string
  お届け先アパートマンション名: string
  'お届け先会社・部門１': string
  'お届け先会社・部門２': string
  お届け先名: string
  'お届け先名(ｶﾅ)': string
  敬称: string
  ご依頼主コード: string
  ご依頼主電話番号: string
  ご依頼主電話番号枝番: string
  ご依頼主郵便番号: string
  ご依頼主住所: string
  ご依頼主アパートマンション: string
  ご依頼主名: string
  'ご依頼主名(ｶﾅ)': string
  品名コード１: string
  品名１: string
  品名コード２: string
  品名２: string
  荷扱い１: string
  荷扱い２: string
  記事: string
  'ｺﾚｸﾄ代金引換額（税込)': string
  内消費税額等: string
  止置き: string
  営業所コード: string
  発行枚数: string
  個数口表示フラグ: string
  請求先顧客コード: string
  請求先分類コード: string
  運賃管理番号: string
  クロネコwebコレクトデータ登録: string
  クロネコwebコレクト加盟店番号: string
  クロネコwebコレクト申込受付番号１: string
  クロネコwebコレクト申込受付番号２: string
  クロネコwebコレクト申込受付番号３: string
  お届け予定ｅメール利用区分: string
  'お届け予定ｅメールe-mailアドレス': string
  入力機種: string
  お届け予定ｅメールメッセージ: string
  お届け完了ｅメール利用区分: string
  'お届け完了ｅメールe-mailアドレス': string
  お届け完了ｅメールメッセージ: string
  クロネコ収納代行利用区分: string
  'クロネコ収納代行利用区分(予備)': string
  '収納代行請求金額(税込)': string
  収納代行内消費税額等: string
  収納代行請求先郵便番号: string
  収納代行請求先住所: string
  '収納代行請求先住所（アパートマンション名）': string
  '収納代行請求先会社・部門名１': string
  '収納代行請求先会社・部門名２': string
  '収納代行請求先名(漢字)': string
  '収納代行請求先名(カナ)': string
  '収納代行問合せ先名(漢字)': string
  収納代行問合せ先郵便番号: string
  収納代行問合せ先住所: string
  '収納代行問合せ先住所（アパートマンション名）': string
  収納代行問合せ先電話番号: string
  収納代行管理番号: string
  収納代行品名: string
  収納代行備考: string
  複数口くくりキー: string
  検索キータイトル1: string
  検索キー1: string
  検索キータイトル2: string
  検索キー2: string
  検索キータイトル3: string
  検索キー3: string
  検索キータイトル4: string
  検索キー4: string
  検索キータイトル5: string
  検索キー5: string
  検索キータイトル予備: string
  検索キー予備: string
  投函予定メール利用区分: string
  '投函予定メールe-mailアドレス': string
  投函予定メールメッセージ: string
  '投函完了メール（お届け先宛）利用区分': string
  '投函完了メール（お届け先宛）e-mailアドレス': string
  '投函完了メール（お届け先宛）メールメッセージ': string
  '投函完了メール（ご依頼主宛）利用区分': string
  '投函完了メール（ご依頼主宛）e-mailアドレス': string
  '投函完了メール（ご依頼主宛）メールメッセージ': string
}

export const CheckoutChannel = {
  app_android: 'app_android',
  app_ios: 'app_ios',
  browser: 'browser',
} as const

export type CheckoutChannel = keyof typeof CheckoutChannel

export const CheckoutChannelMap = {
  [CheckoutChannel.app_android]: 'Android版アプリ',
  [CheckoutChannel.app_ios]: 'iOS版アプリ',
  [CheckoutChannel.browser]: 'ブラウザ版',
} as const
